import { RG_TYPE as r } from "@project-rouge/rg-core";
import { getPerimeter as t } from "../index8.js";
const i = (e) => t(e, [r.EmptySpace]);
export {
  i as getCommercialPerimeter
};
//# sourceMappingURL=index12.js.map
